class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    if (!this.mainDetailsToggle) return;
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;
    this.overlay = this.querySelector(".mega-menu__overlay");


    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    if(this.overlay) {
      this.overlay.addEventListener("mouseenter", this.close.bind(this));
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.menu = document.querySelector(".header__inline-menu");
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', this.menuHandler.bind(this));
    } else {
      this.menuHandler();
    }
  }

  menuHandler() {
    if (!this.menu) return;
    
    const items = this.menu.querySelectorAll("details");
    let scrollPosition = 0;
    
    const disableScroll = () => {
      scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${scrollPosition}px`;
      document.body.style.width = '100%';
    };
    
    const enableScroll = () => {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollPosition);
    };
    
    items.forEach((item) => {
      const dropdown = item.querySelector(".megamenu-content-inner");
      if (!dropdown) return;
      
      const openMenu = () => {
        item.setAttribute("open", "true");
        document.body.style.overflowY = "hidden";
        // Only disable scroll on mobile devices
        if (window.innerWidth < 990) {
          disableScroll();
        }
      };
      
      const closeMenu = () => {
        item.removeAttribute("open");
        document.body.style.overflowY = "";
        const anyOpen = Array.from(items).some((el) => el.hasAttribute("open"));
        if (!anyOpen && window.innerWidth < 990) {
          enableScroll();
        }
      };
      
      item.addEventListener("mouseenter", openMenu);
      item.addEventListener("mouseleave", (e) => {
        if (!dropdown.contains(e.relatedTarget)) {
          closeMenu();
        }
      });
      
      dropdown.addEventListener("mouseenter", openMenu);
      dropdown.addEventListener("mouseleave", (e) => {
        if (!item.contains(e.relatedTarget)) {
          closeMenu();
        }
      });
      
      item.addEventListener("focusin", openMenu);
      item.addEventListener("focusout", (e) => {
        if (!item.contains(e.relatedTarget)) {
          closeMenu();
        }
      });
    });
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;
    
    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);